import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const Stylists = lazy(() => import('pages/stylists'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_public/_empty/stylists')({
  component: StylistsWrapper,
});

function StylistsWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <Stylists />
    </Suspense>
  );
}
